import { render, staticRenderFns } from "./CustomerHistoryDashboardForm.vue?vue&type=template&id=08ddb001&style=overflow-y%3A%20hidden"
import script from "./CustomerHistoryDashboardForm.vue?vue&type=script&lang=js"
export * from "./CustomerHistoryDashboardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports